import { createContext, useEffect, useState } from "react";
import getCountries from "../services/getCountries";
import getProvincias from "../services/WhereToBuy/warehouse/getProvincias";
import getLocalidades from "../services/WhereToBuy/warehouse/getLocalidades";
import getCorralonesConProducto from "../services/WhereToBuy/warehouse/getCorralonConProducto";
import getCorralonLocalidad from "../services/WhereToBuy/getCorralonLocalidad";

const WhereBuyContext = createContext();

const WhereBuyProvider = ({ children }) => {
  const [objSearch, setObjSearch] = useState({});
  const [countries, setCountries] = useState([]);
  const [countriesFilter, setCountriesFilter] = useState([]);
  const [provincias, setProvincias] = useState(null);
  const [provincia, setProvincia] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [corralonesConProducto, setCorralonesConProductos] = useState(null);

  useEffect(() => {
    getCountries().then((resp) => setCountries(resp.country));
    getProvincias().then((resp) => setProvincias(resp.data));
  }, []);

  useEffect(() => {
    const filterCountries = countries.filter((c) => {
      if (c.country_phone_code === 55) {
        return c;
      } else if (c.country_phone_code === 56) {
        return c;
      } else if (c.country_phone_code === 591) {
        return c;
      } else if (c.country_phone_code === 1) {
        return c;
      } else if (c.country_phone_code === 57) {
        return c;
      } else if (c.country_phone_code === 52) {
        return c;
      } else if (c.country_phone_code === 51) {
        return c;
      } else if (c.country_phone_code === 595) {
        return c;
      } else if (c.country_phone_code === 598) {
        return c;
      } else if (c.country_phone_code === 58) {
        return c;
      } else if (c.country_phone_code === 593) {
        return c;
      } else if (c.country_phone_code === 503) {
        return c;
      } else if (c.country_phone_code === 506) {
        return c;
      } else if (c.country_phone_code === 507) {
        return c;
      }
    });
    setCountriesFilter(filterCountries);
  }, [countries]);

  const searchLocalidades = (provincia_id) => {
    setLocalidades(null);
    setObjSearch({
      ...objSearch,
      provincia_id,
    });
    getLocalidades(provincia_id).then((resp) => setLocalidades(resp.data));
  };
  const searchCorralonConProv = (provincia_id) => {
    getCorralonesConProducto({ ...objSearch, provincia_id }, provincia_id).then(
      (resp) => setCorralonesConProductos(resp.data)
    );
    setProvincia(provincia_id);
  };
  const searchCorralonConProd = (localidad_id) => {
    if (localidad_id > 0) {
      getCorralonLocalidad(objSearch, localidad_id).then((resp) =>
        setCorralonesConProductos(
          resp.data
        )
      );
    } else {
      getCorralonesConProducto({ ...objSearch, provincia }, provincia).then(
        (resp) => setCorralonesConProductos(resp.data)
      );
    }
  };

  return (
    <WhereBuyContext.Provider
      value={{
        countries,
        countriesFilter,
        provincias,
        provincia,
        setProvincia,
        localidades,
        setLocalidades,
        corralonesConProducto,
        setCorralonesConProductos,
        searchLocalidades,
        setObjSearch,
        searchCorralonConProd,
        searchCorralonConProv,
      }}
    >
      {children}
    </WhereBuyContext.Provider>
  );
};

export { WhereBuyProvider };

export default WhereBuyContext;
